import React from "react";
import { motion } from "framer-motion";

const ease = [0.83, 0, 0.17, 1];

// A single masked line that slides up into view, reusing the exact reveal
// animation from the original hero. Visual only (renders a <div> so pages can
// keep one real, descriptive <h1> for SEO); pass `as` to change the element.
const RevealHeading = ({ children, delay = 0, as: Tag = "div" }) => (
  <Tag className="reveal-heading">
    <motion.div
      className="h1"
      initial={{ top: "7rem", transition: { duration: 1, ease, delay } }}
      animate={{ top: 0, transition: { duration: 1.5, ease, delay } }}
    >
      {children}
    </motion.div>
    <div className="h1-revealer"></div>
  </Tag>
);

export default RevealHeading;
